const AssetsManager = assetUrl => `${assetUrl}?v=${process.env.ASSETS_VERSION_ENV}`;

export default AssetsManager;